var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1667 2.9238H18V0.523804H15.6667V2.9238H6.33333V0.523804H4V2.9238H2.83333C1.53833 2.9238 0.511667 4.0038 0.511667 5.3238L0.5 22.1238C0.5 23.4438 1.53833 24.5238 2.83333 24.5238H19.1667C20.45 24.5238 21.5 23.4438 21.5 22.1238V5.3238C21.5 4.0038 20.45 2.9238 19.1667 2.9238ZM19.1667 22.1238H2.83333V8.9238H19.1667V22.1238Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9328 12.6242L10.0157 16.8152L7.02301 14.6042C6.88402 14.5012 6.68007 14.5224 6.56888 14.6508C6.45737 14.7797 6.47999 14.9675 6.6193 15.0704L9.85151 17.4584C9.91098 17.5023 9.98242 17.5238 10.0535 17.5238C10.1427 17.5238 10.2316 17.4898 10.2953 17.4235L14.4164 13.0206C14.535 12.8977 14.523 12.7087 14.3895 12.5995C14.2557 12.4896 14.0518 12.5007 13.9328 12.6242Z",
    strokeWidth: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.c10766ba567686659f2a3dc402039340.svg";
export { ForwardRef as ReactComponent };